export { default as AnalisisLatexVer } from './Ver';
export { default as LaboratorioLatexEditar } from './Editar';
export { default as LaboratorioLatexListar } from './Listar';
export { default as PendientesLatexValidar } from './PendientesValidacion'
export { default as HistoricoAnalisisLatex } from './Historico'
